import { useState } from 'react';
import { IconChevronDown, IconFileTypeCsv, IconFileTypeXls } from '@tabler/icons-react';
import { Button, Popover, RowMenu, RowMenuItem } from '@wapharma/design-system';
import styles from './SetupWizard.module.css';

export type SetupTemplateFormat = 'xlsx' | 'csv';

export function SetupWizardTemplateMenu({
  onDownload,
  tabIndex,
  label = 'Modèle',
}: {
  onDownload: (format: SetupTemplateFormat) => void;
  tabIndex?: number;
  label?: string;
}) {
  const [open, setOpen] = useState(false);

  return (
    <Popover
      opened={open}
      onChange={setOpen}
      portal
      align="end"
      fullWidth
      /* Setup drawer sits at modal z — menu must clear it. */
      portalZIndex="var(--wp-z-popover-over-modal)"
      portalMinWidth={200}
      portalEstimatedHeight={120}
      target={
        <Button
          type="button"
          size="sm"
          variant="ghost"
          tabIndex={tabIndex}
          aria-haspopup="menu"
          aria-expanded={open}
          className={styles.templateMenuTrigger}
        >
          <span className={styles.templateBtnLabel}>
            <IconFileTypeXls size={16} stroke={1.5} aria-hidden />
            {label}
            <IconChevronDown size={14} stroke={1.5} aria-hidden />
          </span>
        </Button>
      }
    >
      <RowMenu aria-label="Format du modèle">
        <RowMenuItem
          onClick={() => {
            setOpen(false);
            onDownload('xlsx');
          }}
        >
          <span className={styles.templateBtnLabel}>
            <IconFileTypeXls size={16} stroke={1.5} aria-hidden />
            Excel (.xlsx)
          </span>
        </RowMenuItem>
        <RowMenuItem
          onClick={() => {
            setOpen(false);
            onDownload('csv');
          }}
        >
          <span className={styles.templateBtnLabel}>
            <IconFileTypeCsv size={16} stroke={1.5} aria-hidden />
            CSV (.csv)
          </span>
        </RowMenuItem>
      </RowMenu>
    </Popover>
  );
}
